<template>
  <div class="ques-index">
    <div class="top-div">
      <div class="top top-left" @click="handleClickJump('daily')" v-track="{ functionName: '题库-每日一题' }">
        <div class="top-title">每日一题</div>
        <div class="txt1">
          今日已打卡<span class="col">{{ dailyDetails && dailyDetails.peopleNum }}</span>人
        </div>
        <div class="txt1">
          正确率<span class="col">{{ dailyDetails && dailyDetails.accuracy }}</span>
        </div>
        <div class="left-btn">
          去打卡
          <img src="../../assets/images/questionBank/img(4).png" class="btn-icon" alt="">
        </div>
      </div>
      <div class="top top-right" @click="handleClickJump('bankIndex')" v-track="{ functionName: '题库-分类题库' }">
        <div class="top-title">分类题库</div>
        <div class="txt1">
          海量临床真实电图库
        </div>
        <div class="left-btn right-btn">
          去完成
          <img src="../../assets/images/questionBank/img(4).png" class="btn-icon" alt="">
        </div>
      </div>
    </div>
    <div class="flex-btn">
      <div class="btn-con" @click="handleClickJump('errBank')">
        <img src="../../assets/images/questionBank/img(1).png" class="con-icon" alt="">
        <div class="con-txt">错题库</div>
      </div>
      <div class="btn-con" @click="handleClickJump('collect')">
        <img src="../../assets/images/questionBank/img(2).png" class="con-icon" alt="">
        <div class="con-txt">我的收藏</div>
      </div>
      <div class="btn-con" @click="handleClickJump('achieve')">
        <img src="../../assets/images/questionBank/img(3).png" class="con-icon" alt="">
        <div class="con-txt">我的成就</div>
      </div>
      <div class="btn-con" @click="handleClickJump('ranking')">
        <img src="../../assets/images/questionBank/img(6).png" class="con-icon" alt="">
        <div class="con-txt">排行榜</div>
      </div>
    </div>
    <img src="@/assets/images/questionBank/img(27).png" @click="handleGoCase" class="img-case" alt="">
    <!-- <van-overlay :show="isRemind">
      <div class="dialog-con" @click.stop>
        <div class="title">温馨提示</div>
        <div class="txt">是否接收每日一题打卡提醒?</div>
        <div class="dialog-btn">
          <div class="btn-txt btn-left" @click="handleConfirm('2')">否</div>
          <div class="btn-txt btn-right" @click="handleConfirm('1')">是</div>
        </div>
      </div>
    </van-overlay> -->
    <van-overlay :show="isRead">
      <div class="dialog-con dialog-con2" @click.stop>
        <div class="title">分类题库使用说明</div>
        <div class="txt">
          题库中包含各个病种的实战心电图，您可以自由选择想学习的心电图进行答题自测。答题过程中，您可以随时提交&退出，系统会保留您的答题记录，下次点击未答/答错的题目继续进行答题，全部答对后可解锁更多精彩题库</div>
        <van-checkbox v-model="checked" checked-color="#EB1700" icon-size="16px">不再提示</van-checkbox>
        <div class="dialog-btn" @click="handleCloseRead">
          <div class="btn-txt btn-right btn-txt2">知道了</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { dailyStatistics, dailyRead, updateDailyQuestionRemind, postDailyRead } from '../../api/questionBank'
import { getDaily } from '@/api/api'
import { setSha, traceClickURL } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'

const UserProfile = {
  data () {
    return {
      dailyDetails: {},
      isHasSubject: false,
      isRemind: false,
      isRead: false,
      readType: 'dailyQuestion',
      readTypeName: '每日一题消息阅读',
      checked: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    dailyStatistics().then(res => {
      this.dailyDetails = res.data
    })
    getDaily().then(res => {
      if (!res.data) return
      this.isHasSubject = true
    })
    this.handleIsReadFun()
  },
  methods: {
    handleCloseRead () {
      sessionStorage.setItem('isRead', false)
      this.isRead = false
      if (this.checked) {
        this.handleReadFun()
      } else {
        this.$router.push({
          path: '/disease'
        })
      }
    },
    handleIsReadFun () {
      dailyRead({
        userId: this.userInfo.id,
        readType: this.readType
      }).then(res => {
        if (this.readType === 'dailyQuestion') {
          this.isRemind = !res.data
        }
        if (this.readType === 'questionBnak') {
          this.isRead = sessionStorage.getItem('isRead') ? !!JSON.parse(sessionStorage.getItem('isRead')) : !res.data
          if (!this.isRead) {
            this.$router.push({
              path: '/disease'
            })
          }
        }
      })
    },
    handleReadFun () {
      let params = {
        'iepUserId': this.userInfo.id,
        'readType': this.readType,
        'readTypeName': this.readTypeName
      }
      postDailyRead(params).then(() => {
        if (this.checked) {
          this.$router.push({
            path: '/disease',
          })
        }
      })
    },
    handleConfirm (bool) {
      updateDailyQuestionRemind({
        userId: this.userInfo.id,
        dailyQuestionRemind: bool
      }).then(res => {
        this.isRemind = false
        this.handleReadFun()
      })
    },
    handleClickJump (type) {
      let url = ''
      switch (type) {
        case 'daily':
          if (!this.isHasSubject) {
            this.$toast('暂无题目，请明天再来！')
            return
          }
          url = '/dailyDetails?entrance=8&channel=8'
          break
        case 'bankIndex':
          this.readType = 'questionBnak'
          this.readTypeName = '分类题库消息阅读'
          this.handleIsReadFun()
          return
        case 'errBank':
          url = '/errDisease'
          break
        case 'collect':
          url = '/colDisease'
          break

        default:
          this.$toast('开发中')
          return
      }
      this.$router.push({
        path: url
      })
    },
    handleGoCase() {
      setTimeout(() => { traceClickURL() })
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      window.location.href = `${process.env.bingliUrl}/wap/index.html#/homePage?listType=4${openidBindli}`
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.ques-index {
  padding: 20px 15px;
  box-sizing: border-box;
  background-color: #Fff;
  min-hight: 100vh;

  .top-div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .top {
      background-repeat: no-repeat;
      width: 167px;
      height: 205px;
      background-size: contain;
      padding-left: 16px;
      padding-top: 25px;
      box-sizing: border-box;
      position: relative;

      .top-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 6px;
      }

      .txt1 {
        font-size: 14px;
        color: #949BA5;
        line-height: 24px;

        .col {
          color: #000;
          font-weight: 600;
        }
      }

      .left-btn {
        position: absolute;
        width: 135px;
        left: 50%;
        transform: translateX(-50%);
        height: 32px;
        line-height: 32px;
        background-color: #EB1700;
        border-radius: 100px;
        bottom: 20px;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn-icon {
        width: 5px;
        display: block;
        margin-left: 4px;
      }

      &.top-left {
        background: url('../../assets/images/questionBank/img(20).png') no-repeat center center / 100% 100%;

        .top-title {
          color: #EB1700;
        }

        .left-btn {
          color: #FFF;
        }
      }

      &.top-right {
        background: url('../../assets/images/questionBank/img(21).png') no-repeat center center / 100% 100%;

        .top-title {
          color: #EB1700;
        }

        .left-btn {
          color: #FFF;
        }
      }
    }
  }

  .flex-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px;
    box-sizing: border-box;
    margin-top: 20px;

    .btn-con {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .con-icon {
        width: 44px;
        height: 44px;
        display: block;
        margin-bottom: 3px;
      }

      .con-txt {
        font-size: 12px;
        color: #333333;
        line-height: 20px;
      }
    }
  }

  .dialog-con {
    width: 320px;
    height: 232px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 120px;

    &.dialog-con2 {
      background: #fff;
      border-radius: 10px;
      width: 324px;
      height: 374px;

      .title {
        padding-top: 20px;
      }

      .txt {
        text-align: left;
      }
    }

    .title {
      text-align: center;
      font-size: 17px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 20px;
      line-height: 24px;
    }

    .txt {
      text-align: center;
      font-size: 14px;
      color: rgba(0, 0, 0, .7);
      font-weight: 400;
      padding: 0 26px;
      box-sizing: border-box;
      line-height: 24px;
    }

    .dialog-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid rgba(0, 0, 0, .1);

      .btn-txt {
        text-align: center;
        flex: 1;
        font-size: 17px;
        height: 55px;
        font-weight: 500;
        line-height: 55px;

        &.btn-left {
          color: #9FA5AE;
        }

        &.btn-right {
          color: #EB1700;
          border-left: 1px solid rgba(0, 0, 0, .1);
        }

        &.btn-txt2 {
          color: #EB1700;
        }
      }
    }
  }

  /deep/ .van-checkbox {
    padding: 0 26px;
    box-sizing: border-box;
    margin-top: 26px;

    .van-checkbox__label {
      font-size: 14px;
      color: #EB1700;
    }
  }
}
.img-case {
  width: 100%;
  display: block;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/questionBank/questionIndex.vue